import {loginData, responseLogin, responseToken, responseUserMe} from './transform/UserTransform';
import {handlerError, ApiService} from "../ApiService";

import {notification} from "antd";
import {showAuthMessage} from "../../../redux/actions/Auth";
const UserService = {};

UserService.login = (data) =>
	ApiService.post('/auth/signin', data)
		.then(responseToken)
		.catch(handlerErrorLogin);

UserService.getUserMe = () =>
	ApiService.get('/user/acountinfo')
		.then(responseUserMe)
		.catch(handlerError);

UserService.create = (data) =>
	ApiService.post('/user/create', data)
		.then()
		.catch(handlerError);

UserService.modify = (data) =>
	ApiService.put('/user/edit', data)
		.then()
		.catch(handlerError);

UserService.getCode = (data) =>
	ApiService.post('/otp/email', data)
		.then()
		.catch(handlerError)

UserService.getSMS = (data) =>
	ApiService.post('/notification/sendsms', data)
		.then()
	    .catch(handlerError)		

UserService.getUsers = () =>
	ApiService.get('/bid/getInfo')
		.then(res => res.data)
		.catch(handlerError);

export const handlerErrorLogin = (error) => {
	let notificationParam = { message: '' };
	// Remove token and redirect
	if (error.response.status === 401) {
		notificationParam.message = 'Authentication Fail';
		notificationParam.description = 'Please login again';
		console.log(error)
	}

	if (error.response.status === 404) {
		notificationParam.message = 'Not Found'
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}

	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	notification.error(notificationParam);
	showAuthMessage(notificationParam.message);

	return Promise.reject(error);
};

export default UserService